(function () {
  const companyId = "85fe086ef8";
  const endpoint =
    "https://curio-whisp-app.vercel.app/api/pixel-collect?shop=0531a2.myshopify.com";
  const ingestKey =
    "3a049149ac5b1f46f513502bb1b1d5adb2ba1bc64fe21f39f865b47fdca9dda9";

  const hookState = {
    breezeStartCheckoutPatched: false,
    callUICallbackPatched: false,
    onMerchantEventPatched: false,
    onEventPatched: false,
  };

  const emittedKeys = new Set();

  function getSessionId() {
  try {
    return (
      localStorage.getItem("lively_session_id") ||
      localStorage.getItem("dc_session_id") ||
      window.__dcSessionId ||
      null
    );
  } catch (error) {
    console.error("Unable to read session id", error);
    return window.__dcSessionId || null;
  }
}

  function getClientContext() {
    return {
      userAgent: navigator.userAgent,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      language: navigator.language,
    };
  }

  function getYourTokenContext() {
    const ytapp = window.ytapp || {};
    return {
      cartAmount: ytapp.cartAmount ?? null,
      cartQty: ytapp.cartQty ?? null,
      brandId: ytapp.brandId ?? null,
      brandName: ytapp.brandName ?? null,
    };
  }

  function getLocationContext() {
    return {
      href: window.location.href,
      referrer: document.referrer,
      path: window.location.pathname,
      search: window.location.search,
    };
  }

  function buildEvent(name, data) {
    return {
      name,
      timestamp: new Date().toISOString(),
      clientId: getSessionId(),
      context: {
        document: {
          location: {
            href: window.location.href,
          },
          referrer: document.referrer,
        },
        shop: {
          myshopifyDomain: "0531a2.myshopify.com",
        },
      },
      data,
    };
  }

  async function sendEvent(event, label) {
    console.log("[DC] send start:", label, event);

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Curio-Ingest-Key": ingestKey,
        },
        body: JSON.stringify({
          event,
          clientContext: getClientContext(),
          customContext: {
            companyId,
            livelySessionId: getSessionId(),
            source: "storefront_sdk_hook",
          },
        }),
        keepalive: true,
      });

      console.log("[DC] response:", label, response.status);

      if (!response.ok) {
        console.error("[DC] failed:", label, response.status);
      }
    } catch (error) {
      console.error("[DC] error:", label, error);
    }
  }

  function dedupeKey(name, data) {
    const parts = [
      name,
      getSessionId() || "no-session",
      data && data.step ? data.step : "",
      data && data.orderId ? data.orderId : "",
      data && data.checkoutId ? data.checkoutId : "",
      data && data.paymentGateway ? data.paymentGateway : "",
      data && data.transactionId ? data.transactionId : "",
      window.location.pathname,
    ];
    return parts.join("|");
  }

  function emitOnce(name, data, label) {
    const key = dedupeKey(name, data);
    if (emittedKeys.has(key)) {
      console.log("[DC] deduped:", label, key);
      return;
    }
    emittedKeys.add(key);
    sendEvent(buildEvent(name, data), label);
  }

  function emitCartProceeded(source, extraData) {
    const data = {
      source,
      ...getYourTokenContext(),
      ...getLocationContext(),
      ...extraData,
    };

    console.log("Cart proceeded captured", { source, data });
    emitOnce("cart_proceeded", data, "cart_proceeded");
  }

  function emitSdkReady(source, extraData) {
    const data = {
      source,
      ...getYourTokenContext(),
      ...getLocationContext(),
      ...extraData,
    };

    console.log("Checkout SDK ready", { source, data });
    emitOnce("checkout_sdk_ready", data, "checkout_sdk_ready");
  }


function patchFunction(target, key, stateKey, handler) {
  if (!target || typeof target[key] !== "function") {
    return false;
  }

  if (target[key].__dcPatched) {
    hookState[stateKey] = true;
    return true;
  }

  const original = target[key];

  async function wrapped(...args) {
    try {
      await handler.apply(this, args);
    } catch (error) {
      console.error("Patch handler failed for", key, error);
    }

    return original.apply(this, args);
  }

  wrapped.__dcPatched = true;
  target[key] = wrapped;
  hookState[stateKey] = true;

  console.log("[DC] patched function:", key);
  return true;
}

  function extractStructuredFields(detail) {
    return {
      checkoutId:
        detail?.checkoutId ||
        detail?.checkout_id ||
        detail?.data?.checkoutId ||
        detail?.data?.checkout_id ||
        null,
      orderId:
        detail?.orderId ||
        detail?.order_id ||
        detail?.data?.orderId ||
        detail?.data?.order_id ||
        detail?.breezeOrderId ||
        null,
      paymentGateway:
        detail?.paymentGateway ||
        detail?.payment_gateway ||
        detail?.gateway ||
        detail?.paymentMethod ||
        detail?.payment_method ||
        detail?.data?.paymentGateway ||
        detail?.data?.gateway ||
        null,
      paymentStatus:
        detail?.paymentStatus ||
        detail?.payment_status ||
        detail?.status ||
        detail?.data?.paymentStatus ||
        detail?.data?.payment_status ||
        null,
      transactionId:
        detail?.transactionId ||
        detail?.transaction_id ||
        detail?.pgTransactionId ||
        detail?.pg_transaction_id ||
        detail?.data?.transactionId ||
        detail?.data?.transaction_id ||
        null,
      hasAddress: Boolean(
        detail?.address ||
          detail?.shippingAddress ||
          detail?.deliveryAddress ||
          detail?.data?.address ||
          detail?.data?.shippingAddress ||
          detail?.data?.deliveryAddress
      ),
      rawDetail: detail,
      rawDetailString: JSON.stringify(detail || {}),
    };
  }

  function classifyRuntimeDetail(detail) {
    const fields = extractStructuredFields(detail);

    if (fields.orderId) {
      return { eventName: "order_placed", fields };
    }

    if (
      fields.paymentStatus &&
      String(fields.paymentStatus).toLowerCase() === "success"
    ) {
      return { eventName: "payment_done", fields };
    }

    if (fields.transactionId) {
      return { eventName: "payment_done", fields };
    }

    if (fields.paymentGateway) {
      return { eventName: "payment_gateway_selected", fields };
    }

    if (fields.hasAddress) {
      return { eventName: "address_entered", fields };
    }

    return null;
  }

  function recordRuntimeCallback(source, payload) {
    const structured = extractStructuredFields(payload);

    sendEvent(
      buildEvent("breeze_runtime_callback", {
        source,
        ...getYourTokenContext(),
        ...getLocationContext(),
        ...structured,
      }),
      "breeze_runtime_callback"
    );

    const classified = classifyRuntimeDetail(payload);
    if (!classified) return;

    console.log(
      "[DC] classified runtime event:",
      classified.eventName,
      classified.fields
    );

    emitOnce(
      classified.eventName,
      {
        source,
        ...getYourTokenContext(),
        ...getLocationContext(),
        ...classified.fields,
        step: classified.eventName,
      },
      classified.eventName
    );
  }

  function handleParentCompEvent(detail) {
    const structured = extractStructuredFields(detail);

    sendEvent(
      buildEvent("breeze_parent_component_event", {
        ...getYourTokenContext(),
        ...getLocationContext(),
        ...structured,
      }),
      "breeze_parent_component_event"
    );
  }

  async function persistCartTrackingAttributes() {
    const sessionId = getSessionId();
    if (!sessionId) return;

    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
        keepalive: true,
        body: JSON.stringify({
          attributes: {
            lively_session_id: sessionId,
            _dc_session_id: sessionId,
            user_agent: navigator.userAgent || "",
          },
        }),
      });

      if (!response.ok) {
        console.error("[DC] cart attribute persistence failed", response.status);
        return;
      }

      const cart = await response.json();
      console.log("[DC] cart attributes persisted", cart.attributes);
    } catch (error) {
      console.error("[DC] cart attribute persistence error", error);
    }
  }

  function installHooks() {
    if (window.ytapp && !window.__dcYtappSeen) {
      window.__dcYtappSeen = true;
      emitSdkReady("ytapp-ready", { hasYtapp: true });
    }

    if (!window.__dcCartAttrsPersistedOnce) {
      window.__dcCartAttrsPersistedOnce = true;
      persistCartTrackingAttributes();
    }

    if (window.breeze) {
      patchFunction(
        window.breeze,
        "startCheckout",
        "breezeStartCheckoutPatched",
        async function (cartData) {
          await persistCartTrackingAttributes();

          emitCartProceeded("breeze.startCheckout", {
            hasCartData: Boolean(cartData),
            cartData: cartData || null,
            checkoutSelector: window.checkoutSelector || null,
          });
        }
      );
    }

    patchFunction(window, "callUICallback", "callUICallbackPatched", function () {
      console.log("[DC] callUICallback intercepted", arguments);
      recordRuntimeCallback("callUICallback", arguments[0] || null);
    });

    patchFunction(window, "onMerchantEvent", "onMerchantEventPatched", function () {
      console.log("[DC] onMerchantEvent intercepted", arguments);
      recordRuntimeCallback("onMerchantEvent", arguments[0] || null);
    });

    patchFunction(window, "onEvent", "onEventPatched", function () {
      console.log("[DC] onEvent intercepted", arguments);
      recordRuntimeCallback("onEvent", arguments[0] || null);
    });

    return (
      hookState.breezeStartCheckoutPatched ||
      hookState.callUICallbackPatched ||
      hookState.onMerchantEventPatched ||
      hookState.onEventPatched
    );
  }

  window.addEventListener("ytapp-ready", function (event) {
    console.log("ytapp-ready fired", event.detail);
    emitSdkReady("ytapp-ready-event", {
      detail: event.detail || null,
    });
    installHooks();
  });

  window.addEventListener("parentCompEvent", function (event) {
    console.log("parentCompEvent fired", event.detail);
    handleParentCompEvent(event.detail || null);
  });

  let attempts = 0;
  const maxAttempts = 180;

  const interval = setInterval(function () {
    attempts += 1;
    installHooks();

    const allRuntimeHooksPatched =
      hookState.breezeStartCheckoutPatched &&
      hookState.callUICallbackPatched &&
      hookState.onMerchantEventPatched &&
      hookState.onEventPatched;

    if (allRuntimeHooksPatched || attempts >= maxAttempts) {
      clearInterval(interval);
      console.log("Storefront checkout hooks status", {
        attempts,
        hasBreeze: Boolean(window.breeze),
        hasBzLogButtonClick: typeof window.bzLogButtonClick === "function",
        hasYtapp: Boolean(window.ytapp),
        hasCallUICallback: typeof window.callUICallback === "function",
        hasOnMerchantEvent: typeof window.onMerchantEvent === "function",
        hasOnEvent: typeof window.onEvent === "function",
        breezeStartCheckoutPatched: hookState.breezeStartCheckoutPatched,
        callUICallbackPatched: hookState.callUICallbackPatched,
        onMerchantEventPatched: hookState.onMerchantEventPatched,
        onEventPatched: hookState.onEventPatched,
      });
    }
  }, 1000);
})();